import React, { useState, useEffect, useContext } from 'react';
import App from '@components/Layouts/App';
import Header from '@components/Header/Header';
import Promotion from '@components/Promotion/Promotion';
import Banner from '@components/Banner';
import Footer from '@components/Footer';
import SelectLeague from '@components/Modals/SelectLeagueModal/index';
import { useSiteInfo } from '@contexts/SiteInfoContext';
import { LoginDataContext } from '@contexts/LoginDataContext';
import LoginModal from '../Modals/LoginModal/LoginModal';
import UMModal from '../Modals/UMModal/UMModal';
import CopySiteWarningModal from '../Modals/CopySiteWarningModal/CopySiteWarningModal';
import SiteMapping from '../../configs/siteMapping';
import GoToTopButton from '../GoToTopButton';
import PreLoaderOverlay from '../common/PreLoaderOverlay';
import { HeaderContext } from '../../contexts/HeaderContext';
import MemberRulesPage from '../../pages/memberRules/index';
import isUserBrowserIE from '../../utils/isUserBrowserIE';
import BrowserUpgradePage from '../../pages/browserUpgrade';
import { getDomainName, getUrlParameter } from '../../utils/domainUtils';
import TopBar from '../TopBar/TopBar';

const partialMainConfig = {
    [SiteMapping.viva88]: [<Promotion />],
    [SiteMapping.bong88]: [<Promotion />],
    [SiteMapping.IBCBet]: [<Banner />, <Promotion />],
    [SiteMapping.PICA88]: [<Banner />, <Promotion />],
    [SiteMapping.Nova88]: [<Banner />, <Promotion />],
    [SiteMapping.id8899]: [<Banner />, <Promotion />],
    [SiteMapping.bettha88]: [<Banner />, <Promotion />],
    [SiteMapping.taraPlays]: [<Banner />, <Promotion />],
    [SiteMapping.fifabet]: [<Banner />, <Promotion />],
    [SiteMapping.ocean99]: [<Banner />, <Promotion />],
};

const footerSiblingConfig = {
    [SiteMapping.viva88]: [<SelectLeague />, <LoginModal />, <GoToTopButton />, <UMModal />, <CopySiteWarningModal />],
    [SiteMapping.bong88]: [<SelectLeague />, <LoginModal />, <GoToTopButton />, <UMModal />],
    [SiteMapping.IBCBet]: [<SelectLeague />, <LoginModal />, <GoToTopButton />, <UMModal />],
    [SiteMapping.PICA88]: [<SelectLeague />, <LoginModal />, <GoToTopButton />, <UMModal />],
    [SiteMapping.Nova88]: [<SelectLeague />, <LoginModal />, <GoToTopButton />, <UMModal />],
    [SiteMapping.id8899]: [<SelectLeague />, <LoginModal />, <GoToTopButton />, <UMModal />],
    [SiteMapping.bettha88]: [<SelectLeague />, <LoginModal />, <GoToTopButton />, <UMModal />],
    [SiteMapping.taraPlays]: [<SelectLeague />, <LoginModal />, <GoToTopButton />, <UMModal />],
    [SiteMapping.fifabet]: [<SelectLeague />, <LoginModal />, <GoToTopButton />, <UMModal />],
    [SiteMapping.ocean99]: [<SelectLeague />, <LoginModal />, <GoToTopButton />, <UMModal />],
};

const Layout = ({ children }) => {
    const { siteName, isDeniedIp } = useSiteInfo();
    const [device, setDevice] = useState('desktop');
    const [isIEBrowser, setIsIEBrowser] = useState(false);
    const [state, dispatch] = useContext(HeaderContext);
    const [loginData] = useContext(LoginDataContext);

    const renderComponents = (components) => {
        return (
            components.map((component, index) => (
                <React.Fragment key={index}>
                    { component }
                </React.Fragment>
            )));
    };

    useEffect(() => {
        setIsIEBrowser(isUserBrowserIE());
    }, []);

    useEffect(() => {
        const modalParam = getUrlParameter('modal');
        if (modalParam === 'login') {
            dispatch({ type: 'SHOW_LOGIN_POPUP' });
        }
    }, [dispatch]);

    if (isIEBrowser) return <BrowserUpgradePage />;

    if (loginData.isShowMemberRules) return <MemberRulesPage />;

    const showTopBar = () => {
        return {
            [SiteMapping.Nova88]: true,
            [SiteMapping.viva88]: true,
            [SiteMapping.bong88]: true,
            [SiteMapping.IBCBet]: true,
            [SiteMapping.PICA88]: true,
            [SiteMapping.id8899]: true,
            [SiteMapping.bettha88]: true,
            [SiteMapping.taraPlays]: true,
            [SiteMapping.fifabet]: true,
            [SiteMapping.ocean99]: true,
        }[siteName];
    };

    return (
        <>
            <PreLoaderOverlay />
            <App>
                {showTopBar() ? <TopBar /> : null}
                <Header />
                <div className="main">
                    {renderComponents(partialMainConfig[siteName])}
                    {children}
                </div>
                <Footer />
                {renderComponents(footerSiblingConfig[siteName])}
            </App>
        </>
    );
};

export { Layout, partialMainConfig, footerSiblingConfig };
